import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css/normalize.css'
import '@/styles/index.less' // 全部css
// import WxLogin from 'vue-wxlogin'
import '@/icons'

import {
  Row, Col, Main, Header, Footer, Container, Aside, Input
  , Button, Carousel, CarouselItem, Menu, MenuItem, InfiniteScroll, Card, Divider
  , TabPane, Tabs
  , Tag
  , Image
  , Avatar
  , Breadcrumb
  , BreadcrumbItem
  , CascaderPanel
  , Link
  , Table
  , TableColumn
  , Select
  , Option
  , Upload
  , FormItem
  , Form
  , Tooltip
  , Dialog
  , Message
  , Steps
  , Step
  , CheckboxGroup
  , Checkbox
  , Icon
  , MessageBox
  , Popover
  , Descriptions
  , DescriptionsItem
} from 'element-ui'

// 使用组件进行布局
Vue.config.productionTip = false
/* Vue.component('wxLogin', WxLogin) */
// Vue.use(WxLogin)
// Vue.use(Message)
Vue.use(Container)
Vue.use(Footer)
Vue.use(Aside)
Vue.use(Header)
Vue.use(Main)
Vue.use(Col)
Vue.use(Row)
Vue.use(Input)
Vue.use(Button)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(InfiniteScroll)
Vue.use(Card)
Vue.use(Divider)
Vue.use(TabPane)
Vue.use(Tabs)
Vue.use(Tag)
Vue.use(Image)
Vue.use(Avatar)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(CascaderPanel)
Vue.use(Link)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
Vue.use(Upload)
Vue.use(FormItem)
Vue.use(Form)
Vue.use(Tooltip)
Vue.use(Dialog)
Vue.use(Steps)
Vue.use(Step)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Icon)

Vue.use(Popover)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)

Vue.prototype.$message = Message
// 重新定义
Vue.prototype.$alert = MessageBox.alert

// main.js

const EventBus = new Vue()
Vue.prototype.$bus = EventBus // 全局挂载

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
